
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { blobDownload } from '../../../util';
import { initClient } from '../../../api';
import { LinkCollection, CollectionQrRequest, LinksApiUiClient } from '../../backend/backendapi';

@Component
export default class CollectionPrintModal extends Vue {
  collections: LinkCollection[] = [];
  columns: 1 | 2 | 3 = 1;

  //api
  private readonly service = initClient(LinksApiUiClient);

  public open(collections: LinkCollection[]): void {
    this.collections = collections;
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  private generateQR() {
    if (!this.collections.length) {
      return;
    }

    this.service.collectionQr(new CollectionQrRequest({ columns: this.columns, collectionIds: this.collections.map(e => e.id) }))
        .then(response => response.data)
        .then(blob => {
          blobDownload(blob, 'qrcode.pdf');
          this.dismiss();
        });
  }
}
